import React from 'react';
import { InputItem } from 'antd-mobile';
import WrapComponent from './WrapComponent';

class PhoneNumber extends React.Component{
    render(){
        let {api_name, form, is_readonly, is_required, default_value, errorText,check_message = '',check_pattern=''} = this.props;
        const {getFieldProps} = form;
        let tempProps = {
            type: 'tel',
            name: api_name,
            disabled: is_readonly,
            placeholder: $st('请输入')
        }
        let fieldProps = getFieldProps(api_name, {
            initialValue: default_value,
            validate: [{
                trigger: 'onChange',
                rules: [{
                    required: is_required,
                    message: $st($st(`paas.smart.form.isrequired`))
                }],
            },
            {
                trigger: 'onChange',
                rules: [{
                    validator: (rule, value, callback) => {
                        const pattern1 = /^[0-9+-;(),]{0,100}$/;
                        const pattern2 = new RegExp(check_pattern);
    
                        if (value && (!pattern1.test(value) || !pattern2.test(value))) {
                            callback(check_message || $st('手机号格式不正确'));
                        } else {
                            callback();
                        }
                    }
                }]
            }]
        });
        
        return (
            <InputItem {...tempProps} {...fieldProps} >
                {errorText && <div className='input-error'>{errorText}</div>}
            </InputItem>
        )
    }
    
}
export default WrapComponent(PhoneNumber);


// WEBPACK FOOTER //
// ./src/component/PhoneNumber.js